export default [{
    path: '/node/stateNode',
    name: 'stateNode',
    meta: {
      index: 15
    },
    component: () => import('@/views/node/stateNode.vue')
  }]
  